import { NgIf } from '@angular/common';
import { NgModule } from '@angular/core';

import { DetachedRouterModule } from '@recruitee/common';
import { I18nModule } from '@recruitee/i18n';
import {
  AvatarComponent,
  ButtonComponent,
  ButtonLoadingDirective,
  GroupComponent,
  HeadingComponent,
  IconButtonComponent,
  IconComponent,
  InputComponent,
  MessageComponent,
  SpinnerComponent,
} from '@recruitee/user-interface';

import { RtoAvatarInputComponent } from './avatar-input/avatar-input.component';
import { RtoErrorComponent } from './error-box/error-box.component';
import { RtoMultilineButtonComponent } from './multiline-button/multiline-button.component';
import { OnboardingApiService } from './onboarding-api.service';
import { RtoPasswordInputComponent } from './password-input/password-input.component';
import { RtoPhoneInputComponent } from './phone-input/phone-input.component';
import { RtoProgressBarComponent } from './progress-bar/progress-bar.component';
import { StepTemplateComponent } from './step-template/step-template.component';
import { RtoWelcomeImgComponent } from './welcome-img/welcome-img.component';

@NgModule({
  imports: [
    I18nModule,
    DetachedRouterModule,
    IconComponent,
    ButtonComponent,
    InputComponent,
    AvatarComponent,
    HeadingComponent,
    MessageComponent,
    GroupComponent,
    IconButtonComponent,
    ButtonLoadingDirective,
    SpinnerComponent,
    NgIf,
  ],
  providers: [OnboardingApiService],
  declarations: [
    RtoProgressBarComponent,
    RtoAvatarInputComponent,
    RtoPhoneInputComponent,
    RtoWelcomeImgComponent,
    StepTemplateComponent,
    RtoErrorComponent,
    RtoPasswordInputComponent,
    RtoMultilineButtonComponent,
  ],
  exports: [
    RtoProgressBarComponent,
    RtoAvatarInputComponent,
    RtoPhoneInputComponent,
    RtoWelcomeImgComponent,
    StepTemplateComponent,
    RtoErrorComponent,
    I18nModule,

    DetachedRouterModule,
    RtoPasswordInputComponent,
    RtoMultilineButtonComponent,
  ],
})
export class OnboardingSharedModule {}
